// https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html
function russianPlurals(choice: number): number {
  type RussianPossiblePluralForm = "one" | "few" | "many" | "other";
  const form = new Intl.PluralRules("ru", { type: "cardinal" }).select(choice) as RussianPossiblePluralForm;
  return { one: 0, few: 1, many: 2, other: 3 }[form];
}

export { russianPlurals };
